<template>
  <v-stepper alt-labels v-model="e1">
    <v-stepper-header>
      <v-stepper-step :complete="e1 > 1" step="1">Select device</v-stepper-step>
      <v-divider></v-divider>
      <v-stepper-step :complete="e1 > 2" step="2">Setup device</v-stepper-step>
      <v-divider></v-divider>
      <v-stepper-step :complete="e1 > 3" step="3">Register device</v-stepper-step>
      <v-divider></v-divider>
      <v-stepper-step step="4">Add information</v-stepper-step>
    </v-stepper-header>
    <v-stepper-items>
      <Step1 step="1" v-bind:e1.sync="e1" :type="type"></Step1>
      <Step2 step="2" v-bind:e1.sync="e1"></Step2>
      <Step3 step="3" v-bind:e1.sync="e1" :type="type"></Step3>
      <Step4 step="4" v-bind:e1.sync="e1" :type="type"></Step4>
    </v-stepper-items>
  </v-stepper>
</template>
<script>
import Step1 from '@/components/AddDevice/Step1.vue';
import Step2 from '@/components/AddDevice/Step2.vue';
import Step3 from '@/components/AddDevice/Step3.vue';
import Step4 from '@/components/AddDevice/Step4.vue';
import gql from 'graphql-tag';
import EventBus from '@/utils/EventBus';

const SUBSCRIPTION_DEVICES = gql`
subscription get_devices {
  devices(
    order_by: { created_at: desc }
    limit: 1
  ) {
    id
    code
    serial
    firmware
  }
}
`;

export default {
  name: 'AddDeviceStepper',
  props: {
    type: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      e1: 1,
    };
  },
  components: {
    Step1,
    Step2,
    Step3,
    Step4,
  },
  mounted() {
  },
  apollo: {
    $subscribe: {
      devices: {
        query: SUBSCRIPTION_DEVICES,
        result(data) {
          const { devices } = data.data;
          devices.forEach((device) => {
            const {
              id,
              code,
              serial,
              firmware,
            } = device;
            EventBus.$emit('device-registered', {
              id, code, serial, firmware,
            });
          });
        },
      },
    },
  },
};
</script>
